import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IRowColStartEnd, ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { convertCmToPx, convertPxToCm } from '@src/slide/infrastructure/module/independent/unit';
import { NumberInputFrom } from '@tencent/wb-ext-form';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { INPUT_PROPS_CALLBACK_KEY } from '../../../constants';

@Feature()
export class RowColSizeFeature extends BaseDrawerFeature {
    public isBestPlayScale: boolean;
    /**
     * 缓存修改表格单元格大小的选区
     */
    public tableSelectRange?: IRowColStartEnd | null;

    public constructor() {
        super();
    }

    /**
     * 获取选择的单元格的尺寸
     * 多选时取左上第一个单元格
     */
    public getTableColSize(): { width: number, height: number } {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.TABLE) return { width: 0, height: 0 };
        const tableModel = model as ITableModel;
        const { rowStart = 0, colStart = 0 } = tableModel.selectedRange || {};
        return {
            width: convertPxToCm(Math.ceil(tableModel.cellWidth(colStart, 1))),
            height: convertPxToCm(Math.ceil(tableModel.cellHeight(rowStart, 1))),
        };
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.TABLE_ROW_COL_SIZE, 'initTableSelectRange', 'resetTableSelectRange')
    public updateWidthOfTableCols(updateProps: number, from: NumberInputFrom): void {
        if (this.isInputOnlyChangeUI()) return;
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.TABLE) return;
        const tableModel = model as ITableModel;
        tableModel.showSelection = true;
        tableModel.resizeSelectedMultiCol(convertCmToPx(updateProps), this.tableSelectRange);
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.TABLE_ROW_COL_SIZE, 'initTableSelectRange', 'resetTableSelectRange')
    public updateWidthOfTableRows(updateProps: number, from: NumberInputFrom): void {
        if (this.isInputOnlyChangeUI()) return;
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.TABLE) return;
        const tableModel = model as ITableModel;
        tableModel.showSelection = true;
        tableModel.resizeSelectedMultiRow(convertCmToPx(updateProps), this.tableSelectRange);
    }

    // 传递给 handleInputBlurInitAndReset 装饰符调用
    private initTableSelectRange = () => {
        // 避免失焦切换元素时选区丢失
        if (typeof this.tableSelectRange === 'undefined') {
            const { selectedRange } = this.getSelectModel() as ITableModel;
            if (selectedRange) {
                const { rowStart, colStart, rowEnd, colEnd } = selectedRange;
                this.tableSelectRange = { rowStart, colStart, rowEnd, colEnd };
            } else {
                this.tableSelectRange = null;
            }
        }
    };

    // 传递给 handleInputBlurInitAndReset 装饰符调用
    private resetTableSelectRange = () => {
        this.tableSelectRange = undefined;
    };
}
